import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const subscribeNewsletter = (data) =>
  api.post("/newsletter/subscribe", data).then((r) => r.data);

export const submitContact = (data) =>
  api.post("/contact", data).then((r) => r.data);

export const createCheckout = (data) =>
  api.post("/payments/create-checkout-session", data).then((r) => r.data);

export const getSession = (id) =>
  api.get(`/payments/session/${id}`).then((r) => r.data);

export const listPosts = () => api.get("/blog").then((r) => r.data);
export const getPost = (slug) => api.get(`/blog/${slug}`).then((r) => r.data);
